



























































import { getConfig, updateConfig } from '../gameConfig'
import { Vue, Component, Watch } from 'vue-property-decorator'

@Component
export default class Multiply extends Vue {
	config = {
		places: 1,
		numbers: [],
	}

	get complexityList() {
		return [1, 10, 100, 1000]
	}

	get isCustomBgEnabled() {
		return !!this.$store.getters.primaryBackground
	}

	get digits() {
		return {
			small: [1, 2, 3, 4, 5, 6, 7, 8, 9],
			medium: [11, 12, 13, 14, 15, 16, 17, 18, 19],
			big: [10, 20, 30, 40, 50, 60, 70, 80, 90],
		}
	}

	startGame() {
		this.$store.commit('changeGameConfig', this.config)
		this.$router.push({ path: '/games/game' })
	}

	@Watch('config', { deep: true })
	onConfigChanged(val: any) {
		updateConfig({ multiply: () => val })
	}

	created() {
		// Setup default values
		const config = getConfig()
		this.config = config.multiply as any

		// @ts-ignore
		if (this.config.numbers.includes(100)) {
			this.config.numbers = this.config.numbers.filter(i => i !== 100)

			console.log('100 true')
		}
	}
}
